import { createContext, useContext, useState } from 'react';

const LoggingContext = createContext();

export const useLogging = () => {
    return useContext(LoggingContext);
};

export const LoggingProvider = ({ children }) => {
    const [logs, setLogs] = useState([]);

    const addLog = (message) => {
        const timestamp = new Date().toISOString();
        const newLog = `[${timestamp}] ${message}`;
        setLogs((prevLogs) => [...prevLogs, newLog]);
        //console.log(newLog);
    };

    const clearLogs = () => {
        setLogs([]);
    };

    const copyLogsToClipboard = () => {
        const logsText = logs.join('\n');
        navigator.clipboard
            .writeText(logsText)
            .then(() => {
                console.log('Logs copied to clipboard');
            })
            .catch((err) => {
                console.error('Failed to copy logs: ', err);
            });
        return saveLogsToFile(logsText);
    };

    const saveLogsToFile = (logsText) => {
        const blob = new Blob([logsText], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        // Generate and format the timestamp
        const now = new Date();
        const timestamp = now.toISOString().replace(/[:.]/g, '-'); // Replace colons and dots with hyphens

        const fileName = `amrutvaani-logs-${timestamp}.txt`; // Append timestamp to file name

        const a = document.createElement('a');
        a.href = url;
        a.download = fileName; // Append timestamp to file name

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        return { url, fileName };
    };

    return (
        <LoggingContext.Provider value={{ logs, addLog, copyLogsToClipboard, clearLogs }}>
            {children}
        </LoggingContext.Provider>
    );
};
